import {
  AdvancedQueryColumnFilter,
  AdvancedQueryColumnSort,
  EmailEvaluationSummaryDto,
  CreateEmailEvaluationRequest,
  EmailEvaluationDetailDto,
  UpdateEmailEvaluationRequest,
  EmptyResponse,
  Error,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  Response,
  AdvancedQueryPage,
  OptionItemDto,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class EmailEvaluationsService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static getAll(
    params: {
      /**  */
      page?: number;
      /**  */
      pageSize?: number;
      /**  */
      searchFieldNames?: string[];
      /**  */
      searchSearchText?: string;
      /**  */
      searchExactMatch?: boolean;
      /**  */
      filtered?: AdvancedQueryColumnFilter[];
      /**  */
      sorted?: AdvancedQueryColumnSort[];
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<AdvancedQueryPage<EmailEvaluationSummaryDto>>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/email-evaluations';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = {
        Page: params['page'],
        PageSize: params['pageSize'],
        'Search.FieldNames': params['searchFieldNames'],
        'Search.SearchText': params['searchSearchText'],
        'Search.ExactMatch': params['searchExactMatch'],
        Filtered: params['filtered'],
        Sorted: params['sorted']
      };

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static create(
    params: {
      /** requestBody */
      body?: CreateEmailEvaluationRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<EmailEvaluationDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/email-evaluations';

      const configs: IRequestConfig = getConfigs('post', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<EmailEvaluationDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/email-evaluations/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static update(
    params: {
      /**  */
      id: number;
      /** requestBody */
      body?: UpdateEmailEvaluationRequest;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Response<EmailEvaluationDetailDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/email-evaluations/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json-patch+json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static deleteById(
    params: {
      /**  */
      id: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<EmptyResponse> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/email-evaluations/{id}';
      url = url.replace('{id}', params['id'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null as any;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}
